import { apiFetch } from './auth-service';

export interface AvailabilitySlot {
  day: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';
  startTime: string;
  endTime: string;
}

export interface MentorAvailabilityDoc {
  slots: AvailabilitySlot[];
  setAt?: string;
}

export interface MentorWithSlots {
  mentor: {
    _id: string;
    name: string;
    avatar: string;
    bio: string;
    title: string;
    company: string;
    expertise: string[];
  };
  slots: {
    scheduledAt: string;
    startTime: string;
    endTime: string;
    booked: boolean;
  }[];
}

export const getMentorAvailability = (): Promise<MentorAvailabilityDoc> =>
  apiFetch.get('/mentor-availability/me');

export const saveMentorAvailability = (slots: AvailabilitySlot[]): Promise<MentorAvailabilityDoc> =>
  apiFetch.put('/mentor-availability/me', { slots });

export const getMentorSlots = (days = 3): Promise<MentorWithSlots[]> =>
  apiFetch.get(`/mentor-availability/slots?days=${days}`);
